/*!
* name ZJX  学生资源审核详情页
* Copyright 2018-2019
*/
<template>
  <div>
    <div class="resourcedetails_content" style="padding-top:20px;">
      <div class="resourcedetails_tab_title">
        <span>
          乐画 >
          <a href="javascript:;" @click="goPersonalcenter">个人中心</a>
        </span>
      </div>

      <div class="intro_left clearfix">
        <span class="intro_img"><img :src="resources.userimg" width="30" height="30" alt=""> </span>
        <span class="intro_name">上传者：{{resources.username}}</span>
        <div class="intro_left_content">
          <img class="intro_Modif1" @click="delTatle('tubiao')" src="../../assets/images/Modif.png" alt="">
          <!--<img class="intro_icon_grade" src="../../assets/images/grade.png">-->
          <span v-if="isbiao" class="intro_icon category">{{resources.dongwu}}</span>
          <!--<el-input v-else maxlength="2" @blur="onblur('tubiao')"-->
          <!--style="width: 50px;position: absolute;right:0px;z-index:100" v-model="resources.dongwu"-->
          <!--placeholder="请输入内容"></el-input>-->
          <el-select
            v-else
            v-model="resources.dongwu"
            style="width: 100px;position: absolute;right:0px;z-index:100"
            size="small" @change="handleCategoryChange"
            placeholder="请选择作品类型">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="intro_content">
         <span class="content_tit">
          <p v-if="isColor">{{resources.title}}<img class="intro_Modif" src="../../assets/images/Modif.png" alt=""
                                                    @click="delTatle('title')"></p>
          <el-input v-else class="content_tit_input" style="width: 433px;" @blur="onblur('title')"
                    v-model="resources.title" placeholder="请输入内容"></el-input>
        </span>
        <p class="content_intro">{{resources.userteachername}} 分享于 <i>{{resources.fengxiangshijian}}</i>
                                 作品ID：{{resources.wid}}</p>
        <img :src="item.file_path" v-for="(item,index) in resources.bannerimg" :key="index" width="1000" height="360"
             alt="">
        <div class="intro_je">
           <span class="intro_txt_span">
             <em class="yh_lf"></em>
             <p class="intro_txt_span_p">
               <span v-if="1===2">
                    <img class="intro_Modif2" @click="delTatle('content')" src="../../assets/images/Modif.png" alt="">
                    {{resources.content ? resources.content.substring(0,60) + '...' : ''}}
               </span>
             </p>
             <em class="yh_rh"></em>
            </span>
          <el-input @blur="onblur('textbox')" class="intro_txt_input" type="textarea"
                    :autosize="{ minRows: 2, maxRows: 2}" resize="none"
                    v-model="resources.content" placeholder="请输入内容"></el-input>
          <span class="intro_top"></span>
        </div>
        <!--<div class="intro_content_detail">-->
        <!--{{resources.content}}-->
        <!--</div>-->
      </div>
    </div>
    <div class="intro_content_box">
      <div class="intro_content_border">
        <el-button class="btn_one" type="primary" @click="addComContent(2)">通过并分享</el-button>
        <el-button class="btn_two" type="warning" @click="addComContent(3)">不通过</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex' //引入全局vuex
import publicBanner from '@/components/publicBanner' //引入尾部
import cacheUtils from '@/common/cacheUtils' //调用缓存
import apiInterface from '@/api/index' //接口
export default {
  data () {
    return {
      value2: 10,
      resources: {
        userimg: '',
        username: '',
        userteachername: '',
        dongwu: '',
        typeId: '',
        fengxiangshijian: '',
        bannerimg: '',
        comment: '',
        content: '',
        wid: '',
        title: '',
        teacherList: [],
      },
      isColor: true,
      isFalse: true,
      isbiao: true,
      options: []
    }
  },
  computed: {},
  mounted () {
    this.getWorkTypes()
  },
  components: {},
  created () {
    this.id = this.$route.query.id
    // this.getResourcedetails(this.$route.query.id)
    this.worksDtelsData(this.id)
  },
  methods: {
    formatTooltip (val) {
      return val / 10
    },
    async worksDtelsData (id) {
      try {
        let pdata = await this.$xhr.get(apiInterface.worksDtels + id, {
          params: {}
        })
        this.resources.userimg = pdata.data.author.avatar
        this.resources.username = pdata.data.author.name
        this.resources.title = pdata.data.title
        this.resources.userteachername = pdata.data.author.name
        this.resources.dongwu = pdata.data.type_name
        this.resources.typeId = pdata.data.type_id
        this.resources.fengxiangshijian = pdata.data.created_at
        this.resources.bannerimg = pdata.data.attachments
        this.resources.content = pdata.data.content
        this.resources.comment = pdata.data.comment
        this.resources.wid = pdata.data.wid
        this.resources.teacherList = pdata.data.attachments
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 返回到列表页
    goPersonalcenter () {
      this.$router.push({
        path: '/personalcenter',
      })
    },
    // 修改标题及页签
    delTatle (status) {
      console.log(status)
      if (status == 'title') {
        this.isColor = false
      } else if (status == 'tubiao') {
        this.isbiao = false
      } else {
        // this.isFalse = false
      }
    },
    // 提交接口
    async addComContent (status) {
      try {
        let pdata = await this.$xhr.post(
          apiInterface.worksTeacherAudit + this.id + '/audit',
          {
            title: this.resources.title,
            type_id: this.resources.typeId,
            state: status,
            content: this.resources.content
          }
        )
        if (pdata) {
          this.$router.push({
            path: '/personalcenter'
          })
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 失去焦点
    onblur (status) {
      console.log(status)
      if (status == 'title') {
        this.isColor = true
      } else if (status == 'tubiao') {
        this.isbiao = true
      } else {
        // this.isFalse = true
      }
    },
    // 获取作品类型列表
    async getWorkTypes () {
      try {
        let pdata = await this.$xhr.get(apiInterface.workTypes, {
          params: {}
        })
        if (pdata) {
          let arrList = []
          pdata.data.map(item => {
            let obj = {
              value: item.id,
              label: item.name
            }
            arrList.push(obj)
          })
          this.options = arrList
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    handleCategoryChange (vId) {
      this.isbiao = true
      let obj = {}
      obj = this.options.find((item) => {
        return item.value == vId
      })
      this.resources.typeId = obj.value
      this.resources.dongwu = obj.label
    }
  }
}
</script>

<style lang="scss" scoped>
.resourcedetails_content {
  box-sizing: border-box;
  padding-top: 480px;

  .resourcedetails_tab_title {
    box-sizing: border-box;
    line-height: 15px;
    padding-left: 20px;
  }

  .intro_left {
    padding: 50px 20px 0;

    .intro_img {
      float: left;
      display: inline-block;
      width: 30px;
      height: 30px;

      img {
        border-radius: 50%;
      }
    }

    .intro_name {
      display: inline-block;
      float: left;
      height: 30px;
      font: 12px/30px 'Microsoft YaHei';
      color: #666666;
      padding-left: 10px;
    }

    .intro_icon {
      float: right;
      /*padding-left: 25px;*/
      /*background: url(../../assets/images/grade.png) no-repeat left center;*/
      /*background-size: 40%;*/
      display: inline-block;
      height: 30px;
      font: 12px/30px 'Microsoft YaHei';
      color: #666666;
    }

    .intro_icon_grade {
      /*margin-left: 20px;*/
      right: 60px;
    }
  }

  .intro_content {
    margin-top: -40px;
    padding-bottom: 50px;

    .content_tit {
      display: block;
      font: bold 20px/36px 'Microsoft YaHei';
      color: #666666;
      text-align: center;
      position: relative;
      height: 39px;
    }

    .content_intro {
      display: block;
      text-align: center;
      font: 12px/26px 'Microsoft YaHei';
      color: #333333;
      padding-bottom: 10px;

      i {
        color: #999;
      }
    }

    .intro_je {
      width: 960px;
      height: 120px;
      margin: 0 auto;
      position: relative;
      background: #f5f5f5;
      margin-top: 24px;
      text-align: center;

      .intro_txt_span {
        display: inline-block;
        height: 120px;
        color: #000;
        padding: 0 120px;
        position: relative;

        .yh_lf {
          width: 120px;
          height: 120px;
          position: absolute;
          left: 0;
          top: 0;
          background: url(../../assets/images/quotation_mark1.png) no-repeat left 20px;
        }

        .yh_rh {
          width: 120px;
          height: 120px;
          position: absolute;
          right: 0;
          bottom: 0;
          background: url(../../assets/images/quotation_mark2.png) no-repeat right 80px;
        }
      }

      .intro_top {
        display: block;
        width: 30px;
        height: 14px;
        background: url(../../assets/images/intro_top.png) no-repeat center bottom;
        position: absolute;
        left: 50%;
        top: -14px;
        margin-left: -15px;
      }
    }

    .intro_content_detail {
      width: 960px;
      height: 80px;
      margin: 0 auto;
      margin-top: 24px;
      color: #000;
      text-align: left;
    }

    .teacher_dp {
      padding-top: 40px;
      width: 960px;
      margin: 0 auto;

      .teacher_dp_lf {
        width: 274px;
        height: 290px;
        float: left;
        background: url(../../assets/images/teacher_grade.png) no-repeat center bottom;
        position: relative;

        .my_py {
          width: 74px;
          height: 28px;
          text-align: center;
          position: absolute;
          left: 50%;
          margin-left: -37px;
          bottom: 27px;
          display: block;
          font: 12px/28px 'Microsoft YaHei';
          color: #15e4cb;
          border-radius: 15px;
          border: #15e4cb solid 1px;
          cursor: pointer;
        }
      }

      .teacher_dp_rh {
        width: 274px;
        height: 220px;
        background: url(../../assets/images/students_grade.png) no-repeat center bottom;
      }

      .teacher_li {
        margin-left: -10px;
        float: left;
        width: 695px;

        li {
          width: 190px;
          padding: 0 10px;
          float: left;
          margin-left: 20px;

          .teacher_img {
            display: block;
            width: 80px;
            height: 80px;
            margin: 0 auto;

            img {
              border-radius: 50%;
            }
          }

          .student_img {
            width: 60px;
            height: 60px;
          }

          .teacher_user {
            display: block;
            text-align: center;
            font: bold 14px/40px 'Microsoft YaHei';
            color: #666666;
          }

          .student_user {
            font-weight: 100;
            color: #535353;
          }

          .teacher_fen {
            display: block;
            text-align: center;
            font: bold 36px/56px 'Microsoft YaHei';
            color: #fea200;
          }

          .student_fen {
            font: 14px/46px 'Microsoft YaHei';
          }

          .teacher_fen_txt {
            display: block;
            text-align: center;
            font: 12px/30px 'Microsoft YaHei';
            color: #333333;
          }

          .teacher_intro_txt {
            display: block;
            padding-top: 8px;
            text-align: center;
            font: 12px/16px 'Microsoft YaHei';
            color: #666666;
          }

        }
      }

      .student_li {
        padding-top: 35px;
      }
    }

    .rsfe {
      display: block;
      text-align: center;
      font: bold 30px/74px 'Microsoft YaHei';
      color: #333;
    }

    .block_fen {
      width: 410px;
      margin: 0 auto;

      span {
        display: block;
        float: left;
        width: 45px;
        font: bold 14px/38px 'Microsoft YaHei';
        color: #333;
        text-align: center;
      }

      .block {
        width: 320px;
        float: left;
      }
    }

    .el-button--primary {
      margin: 30px auto 0;
      display: block;
    }
  }
}

.comment_content {
  overflow: hidden;
  margin-top: 50px;
  box-sizing: border-box;
  padding: 0px 200px 0px 200px;

  p {
    span {
      float: left;
      margin-right: 20px;
    }
  }

  p:nth-child(2) {
    margin-top: 50px;

    span {
      color: #fff;
    }
  }
}

.el-select {
  float: left;
}

.el-textarea__inner {
  background: #eeeeee;
}

.intro_Modif {
  margin-left: 7px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: absolute;
  top: 8px;
}

.intro_left_content {
  position: relative;
  float: right;

  img {
    right: 90px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    top: 5px;
    z-index: 20;
  }
}

.intro_Modif2 {
  margin-left: -29px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: absolute;
  top: 18px;
  left: -8px;
}

.intro_content_box {
  overflow: hidden;
  box-sizing: border-box;
  padding: 36px 40px 40px 40px;

  .intro_content_border {
    border-top: 1px solid #f0f0f0;
    height: 100px;
    line-height: 120px;
    text-align: center;

    .btn_one {
      width: 130px;
      background: #15c1e4;
      border: #15c1e4;
      margin-right: 40px;
    }

    .btn_two {
      width: 130px;
      background: #fea200;
      border: #fea200;
      margin-left: 40px;
    }
  }
}

.content_tit_input {
  position: absolute;
  top: 0px;
  right: 221px;
}

.intro_txt_input {
  width: 725px;
  height: 207px;
  position: absolute;
  left: 125px;
  top: 35px;
}

.intro_txt_span_p {
  width: 560px;
  height: 120px;
}

.category {
  &:before {
    content: '';
    width: 50px;
    height: 50px;
    background: url(../../assets/images/grade.png) no-repeat left center;
    background-size: 40%;
    position: absolute;
    left: -30px;
    top: -8px;
  }
}
</style>

